import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", delay = 0, as = "h1", lineClass = "", ...rest }) => {
  const Tag = motion[as];
  return (
    <Tag className={className} {...rest}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${lineClass}`}
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, delay: delay + i * 0.12, ease: EASE }}
          >
            {line}
            {i < lines.length - 1 ? " " : ""}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const PageIntro = ({ eyebrow, title, subtitle, testId }) => (
  <section className="border-b border-line" data-testid={testId}>
    <div className="container-x pb-16 pt-20 sm:pb-24 sm:pt-28">
      <motion.p className="eyebrow" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
        <span className="mr-3 inline-block h-1.5 w-1.5 rounded-full bg-coral align-middle" />
        {eyebrow}
      </motion.p>
      <MaskedLines
        as="h1"
        lines={[title]}
        delay={0.1}
        className="mt-6 max-w-3xl text-4xl font-extrabold tracking-tight text-navy sm:text-5xl lg:text-6xl"
      />
      {subtitle && (
        <motion.p
          className="mt-6 max-w-xl text-base leading-relaxed text-muted md:text-lg"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.5, ease: EASE }}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
